export const LANGUAGES = Object.freeze({
  ENGLISH: {value: "en", name: "English"},
  UKRAINIAN: {value: "uk", name: "Українська"},
});

export const LANG_FORM_KEY = "language";

export const LANG_FORM_ID = "languageForm";
